function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSquareImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.588235%,60.392157%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 2.898438 23.875 L 18.585938 23.875 L 18.585938 19.710938 L 25 19.710938 L 25 4 L 2.898438 4 Z M 4.363281 5.464844 L 23.535156 5.464844 L 23.535156 18.246094 L 17.121094 18.246094 L 17.121094 22.414062 L 4.363281 22.414062 Z M 2.898438 1.074219 L 25 1.074219 L 25 2.539062 L 2.898438 2.539062 Z M 0 4 L 1.464844 4 L 1.464844 23.875 L 0 23.875 Z M 0 4 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(10.588235%,60.392157%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 12.894531 10.425781 L 11.484375 12.792969 L 10.035156 10.425781 L 8.804688 10.425781 L 8.804688 14.867188 L 10.171875 14.867188 L 10.171875 12.914062 L 11.136719 14.46875 L 11.796875 14.46875 L 12.761719 12.84375 L 12.773438 14.867188 L 14.136719 14.867188 L 14.125 10.425781 Z M 16.453125 11.769531 C 16.867188 11.410156 16.960938 11.1875 16.960938 10.933594 C 16.960938 10.417969 16.492188 10.09375 15.792969 10.09375 C 15.140625 10.09375 14.726562 10.359375 14.542969 10.722656 L 15.28125 11.070312 C 15.363281 10.917969 15.507812 10.832031 15.707031 10.832031 C 15.882812 10.832031 15.957031 10.90625 15.957031 11.007812 C 15.957031 11.089844 15.921875 11.191406 15.730469 11.351562 L 14.722656 12.214844 L 14.722656 12.792969 L 17.042969 12.792969 L 17.042969 12.070312 L 16.105469 12.070312 Z M 16.453125 11.769531 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareImage);
export default __webpack_public_path__ + "static/media/squareImage.adb20003e535f432cd648e3c43a46cd9.svg";
export { ForwardRef as ReactComponent };